import React, { createRef, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import toast from 'react-hot-toast';
import { Input, Select } from '../../../components';
import { sanitizeToNumbers } from '../../../utils';
import { CloseIcon, LockIcon, PasswordActive, PasswordInactive, ProfilePhotoIcon } from '../../../assets/icons';
import { AuthService, GeneralService } from '../../../services';

class Profile extends React.Component {

	state = {
		visiblePassword: false,
		form: {
			name: '',
			last_name: '',
			gender_id: '',
			dniType: '',
			dni: '',
			phoneCode: '',
			phone: '',
			birthdate: '',
			email: '',
			current_password: '',
			password: '',
			confirmPassword: '',
		},
		documentTypes: [],
		genders: [],
		phoneCodes: [],
	}

	passwordModalRef = createRef();

	componentDidMount() {
		this.getSelects();
		this.fillForm();
	}

	fillForm = () => {
		const user = this.props.user;

		this.setState({
			form: {
				name: user.name,
				last_name: user.last_name,
				gender_id: user.gender_id || '',
				dniType: user.dni ? String(user.dni).substring(0,1) : '',
				dni: user.dni ? String(user.dni).substring(1) : '',
				phoneCode: String(user.phone).substring(0,4),
				phone: String(user.phone).substring(4),
				birthdate: user.birthdate ? moment(user.birthdate).format('YYYY-MM-DD') : '',
				email: user.email,
				current_password: '',
				password: '',
				confirmPassword: '',
			},
		});
	}

	getSelects = async () => {
		Promise.all([
			GeneralService.getDocumentTypes(),
			GeneralService.getGenders(),
			GeneralService.getPhoneCodes(),
		])
			.then(res => {
				this.setState({
					documentTypes: res[0] ?? [],
					genders: res[1].map(x => ({ value: x.id, label: x.name })) ?? [],
					phoneCodes: res[2] ?? [],
				});
			})
			.catch(console.log);
	}

	change = (value,target) => {
		this.setState({
			form: {
				...this.state.form,
				[target]: value,
			},
		});
	}

	togglePassword = () => {
		this.passwordModalRef.current?.open
			? this.passwordModalRef.current?.close()
			: this.passwordModalRef.current?.showModal();
	}

	isValidPassForm = (showError = true) => {
		const onError = (msg) => {
			if (showError) toast.error(msg);
			return false;
		};

		const { form } = this.state;

		if (!form.current_password)
			return onError('Debe ingresar la contraseña actual');

		if (!form.password)
			return onError('Debe ingresar la nueva contraseña');

		if (form.password !== form.confirmPassword)
			return onError('La contraseñas no coinciden');

		return true;
	}

	isValidForm = (showError = true) => {
		const onError = (msg) => {
			if (showError) toast.error(msg);
			return false;
		};

		const { form } = this.state;

		if (!form.name)
			return onError('El campo nombre es requerido');

		if (!form.last_name)
			return onError('El campo apellido es requerido');

		// if (!form.gender_id)
		// 	return onError('El campo sexo es requerido');

		// if (!form.dniType)
		// 	return onError('El campo tipo de documento es requerido');

		// if (!form.dni)
		// 	return onError('El campo documento de identificación es requerido');

		if (!form.phoneCode)
			return onError('El campo código de área es requerido');

		if (!form.phone)
			return onError('El campo teléfono es requerido');

		// if (!form.birthdate)
		// 	return onError('El campo fecha de nacimiento es requerido');

		if (!form.email)
			return onError('El campo correo es requerido');

		return true;
	}

	submit = async () => {
		if (!this.isValidForm()) return;

		try {
			const data = {
				...this.state.form,
				birthdate: moment(this.state.form.birthdate).format('YYYY-MM-DD'),
			};
			const res = await AuthService.updateProfile(data);

			await this.props.dispatch({
				type: 'SET_USER',
				payload: res,
			});

			toast.success('Perfil actualizado con éxito');

		} catch (error) {
			console.log(error);
		}
	}

	submitPassword = async () => {
		if (!this.isValidPassForm()) return;

		try {
			await AuthService.updatePassword(this.state.form);
			this.togglePassword();

			toast.success('Contraseña actualizada con éxito');

		} catch (error) {
			console.log(error);
		}
	}

	render() {

		const { form } = this.state;
		const hasPhoto = !!this.props.user?.avatarUrl;
		const photo = hasPhoto ? this.props.user?.avatarUrl : ProfilePhotoIcon;

		return (
			<>
				<dialog ref={this.passwordModalRef} className="fixed inset-0 z-50 overflow-y-auto bg-transparent">
					<div className="w-full sm:w-[20rem] bg-white  px-4 py-2 rounded-xl overflow-hidden">
						<div className="flex justify-between items-center">
							<p className="text-lg text-darkBlue font-semibold text-center">
								Cambiar contraseña
							</p>
							<button onClick={() => this.passwordModalRef.current?.close()}>
								<img src={CloseIcon} className="w-3 h-3 object-contain" alt="" />
							</button>
						</div>

						<div className="flex flex-col gap-y-4 my-4">
							<PasswordInput
								placeholder="Contraseña actual"
								secureTextEntry
								value={form.current_password}
								onValueChange={v => this.change(v,'current_password')}
							/>

							<PasswordInput
								placeholder="Nueva contraseña"
								secureTextEntry
								value={form.password}
								onValueChange={v => this.change(v,'password')}
							/>

							<PasswordInput
								placeholder="Repetir contraseña"
								secureTextEntry
								value={form.confirmPassword}
								onValueChange={v => this.change(v,'confirmPassword')}
							/>
						</div>

						<div className="flex justify-between h-12 font-semibold">
							<button className="flex-1 bg-white p-3" onClick={this.togglePassword}>
								<span>Cancelar</span>
							</button>

							<button className="flex-1 text-red" onClick={this.submitPassword}>
								<span>Aceptar</span>
							</button>
						</div>
					</div>
				</dialog>

				<div className="w-full mt-9 lg:mt-0">
					<div className="bg-darkBlue -mt-4 -mx-4 mb-8 pb-8 flex justify-center items-center">
						{hasPhoto ? (
							<img src={photo} className="w-24 h-24 object-cover rounded-full" alt="" />
						) : (
							<div className="w-24 h-24 rounded-full bg-white flex justify-center items-center">
								<img src={photo} className="w-12 h-12 object-contain brightness-0 opacity-50" alt="" />
							</div>
						)}
					</div>

					<div className="max-w-[600px] mx-auto">
						<div className="max-w-[600px] mx-auto grid grid-cols-1 sm:grid-cols-2 gap-4">
							<Input
								placeholder="Nombre"
								value={form.name}
								onValueChange={v => this.change(v,'name')}
								disabled
							/>

							<Input
								placeholder="Apellido"
								value={form.last_name}
								onValueChange={v => this.change(v,'last_name')}
								disabled
							/>

							<Select
								placeholder="Sexo"
								items={this.state.genders}
								value={form.gender_id}
								onValueChange={v => this.change(v,'gender_id')}
								disabled={ this.props.user?.gender_id != null }
							/>

							<div className="flex flex-row items-center gap-x-2 w-full">
								<div className="w-1/3">
									<Select
										items={this.state.documentTypes}
										value={form.dniType}
										onValueChange={v => this.change(v,'dniType')}
										isabled={ this.props.user?.dniType != null }
									/>
								</div>
								<div className="w-2/3 pl-4">
									<Input
										placeholder="Cédula"
										value={form.dni}
										onValueChange={v => this.change(sanitizeToNumbers(v),'dni')}
										maxLength={9}
										isabled={ this.props.user?.dni != null }
									/>
								</div>
							</div>

							<div className="flex flex-row items-center gap-x-2 w-full">
								<div className="w-1/3">
									<Select
										items={this.state.phoneCodes}
										value={form.phoneCode}
										onValueChange={v => this.change(v,'phoneCode')}
									/>
								</div>
								<div className="w-2/3 pl-4">
									<Input
										placeholder="Número de teléfono"
										value={form.phone}
										onValueChange={v => this.change(sanitizeToNumbers(v),'phone')}
										maxLength={7}
									/>
								</div>
							</div>

							<Input
								type="date"
								placeholder="Fecha de nacimiento"
								value={form.birthdate}
								onValueChange={v => this.change(v,'birthdate')}
								disabled={!!this.props.user?.dni_file || !!this.props.user?.fiscal_dni_file}
							/>

							<Input
								placeholder="Correo electrónico"
								value={form.email}
								onValueChange={v => this.change(v,'email')}
							/>

							<button
								className="w-full h-10 rounded-lg flex justify-start items-center px-2 bg-blue"
								onClick={this.togglePassword}
							>
								<img src={LockIcon} className="w-6 h-6 object-contain brightness-0 invert" alt="" />
								<span className="flex-1 font-semibold text-white">Cambiar Contraseña</span>
							</button>
						</div>

						<div className="flex justify-center items-center mt-8">
							<button
								className="rounded-lg text-center h-10 px-16 bg-blue font-bold text-lg text-white"
								onClick={() => {
									if (this.isValidForm()) this.submit();
								}}
							>
								<span>Guardar</span>
							</button>
						</div>
					</div>

				</div>
			</>
		);
	}
}

const PasswordInput = ({ type, value, onValueChange, placeholder, maxLength, secureTextEntry, disabled }) => {
	const [isVisible, setIsVisible] = useState(false);
	return (
		<div className="flex items-center gap-x-4 border border-gray3 bg-white rounded-md h-10 w-full px-2">
			<input
				type={secureTextEntry ? (isVisible ? 'text' : 'password') : (type || "text")}
				className="flex-1 outline-none border-none bg-transparent text-sm"
				placeholder={placeholder}
				value={value}
				onChange={e => onValueChange(e.target.value)}
				maxLength={maxLength}
				disabled={disabled}
			/>
			{secureTextEntry && (
				<button className="focus:outline-none" type="button" onClick={() => setIsVisible(!isVisible)}>
					<img src={isVisible ? PasswordActive : PasswordInactive} className="w-6 h-6" alt="" />
				</button>
			)}
		</div>
	);
}

export default connect(state => ({
	user: state.user,
}))(Profile);
